import React from 'react';
import { cn } from "@/lib/utils";
import GradientLine from "@/components/ui/gradient-line";

type HeadingProps = {
    title: React.ReactNode;
    highlight?: React.ReactNode;
    description?: React.ReactNode;
    className?: string;
    badge?: string;
    showLine?: boolean;
};

const Heading = ({
    title,
    highlight,
    description,
    className,
    badge,
    showLine = true
}: HeadingProps) => {
    return (
        <div className={cn("text-center max-w-3xl mx-auto mb-8 sm:mb-12 md:mb-16 relative z-10", className)}>
            {badge && (
                 <div className="inline-flex items-center justify-center px-4 py-1 sm:px-5 sm:py-1.5 rounded-full bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 shadow-sm mb-4 sm:mb-6">
                    <span className="text-gray-600 dark:text-gray-300 font-semibold text-xs sm:text-sm">{badge}</span>
                </div>
            )}

            <h2 className="text-2xl max-w-5xl mx-auto sm:text-3xl md:text-5xl lg:text-6xl font-bold text-[#181C31] dark:text-white mb-0 tracking-tight">
                {title}{" "}
                {highlight && (
                    <span>
                        {highlight}
                    </span>
                )}
            </h2>

            {showLine && <GradientLine />}

            {description && (
                <p className="text-sm sm:text-base md:text-xl text-[#64657E] dark:text-gray-400 font-medium max-w-2xl mx-auto mt-3 sm:mt-5">
                    {description}
                </p>
            )}
        </div>
    );
};

export default Heading;
